// extracted by css-extract-rspack-plugin
export default {"ReactionsMenuOption":"ReactionsMenuItem-module__ReactionsMenuOption__lZwGKwT"};